import React, { lazy } from 'react';
import { Button } from 'easyship-components';
import { FormattedMessage } from 'react-intl';
import { useOpenModal } from '@/hooks/general/useOpenModal';
import { useClaimShipmentContext } from '@/features/Claim/providers/ClaimShipmentProvider/context';
import useLoadingState from '@/hooks/general/useLoadingState';
import MixpanelService from '@/utils/mixpanel.service';
import { useCompany } from '@app/hooks/general/useCompany';

const ClaimStatusModal = lazy(() => import('@/features/Claim/modals/ClaimStatusModal'));

function ButtonSeeDetails() {
  const { easyshipCompanyId } = useCompany();
  const { shipment } = useClaimShipmentContext();

  const openModal = useOpenModal();

  const { state: isLoading, setLoadingState } = useLoadingState(2000);

  const onClickHandler = () => {
    setLoadingState();
    MixpanelService.track('Insurance Claim Page Viewed', {
      easyship_company_id: easyshipCompanyId,
      easyship_claim_id: shipment?.claim?.id,
      review_state: shipment?.claim?.reviewState,
      payment_state: shipment?.claim?.paymentState,
      provider_claim_status: shipment?.claim?.providerClaimStatus,
    });
    openModal(ClaimStatusModal, {
      shipmentId: shipment?.easyshipShipmentId,
    });
  };
  return (
    <div className="w-full flex items-center justify-center py-2">
      <Button onClick={onClickHandler} loading={isLoading}>
        <FormattedMessage id="global.see-details" />
      </Button>
    </div>
  );
}

export default ButtonSeeDetails;
